import React from 'react';
  import Img from 'gatsby-image';
import imageMap from '@/images/maps/src-map.json';

export default function Image({ src, name, image, ...props }) {
  try {
    const imageSplit = src.split(' ');
    const joinImages =
      imageSplit.length > 1 &&
      imageSplit
        .join('-')
        .toLowerCase()
        .replace('.', '')
        .replace(',', '')
        .replace('(', '')
        .replace(')', '');
    const toLowerCaseImage = joinImages || String(src).toLowerCase();
    const imgData = imageMap[toLowerCaseImage];
    const fluid = imgData;
    if (!fluid) {
      throw String(`${src}, ${name}`);
    }
    return <Img fluid={fluid} {...props} />;
  } catch (source) {
    return <span style={{ position: 'absolute' }} />;
  }
}
